import { useState, ReactNode } from 'react'
import { Menu, X } from '@stratascratch/icons'
import Logo from './Logo'
import Nav, { LinkRenderFn } from './Nav'
import LoggedInAuthMenu from './LoggedInAuthMenu'
import LoggedOutAuthMenu from './LoggedOutAuthMenu'
import './Header.css'

interface Props {
  isAuthenticated?: boolean
  renderThemeSelect?: ReactNode
  renderSearch?: ReactNode
  handleLogout: () => void
  pathname: string | undefined
  renderPlatformLink: LinkRenderFn
  renderGatsbyLink: LinkRenderFn
}

function Header({
  isAuthenticated = false,
  pathname,
  renderPlatformLink,
  renderGatsbyLink,
  handleLogout,
  renderThemeSelect = undefined,
  renderSearch = undefined,
}: Props) {
  const [showMobileNav, setShowMobileNav] = useState(false)

  const toggleMenu = () => {
    document.body.classList.toggle('overflow-hidden')
    setShowMobileNav(!showMobileNav)
  }
  const closeMenu = () => {
    document.body.classList.remove('overflow-hidden')
    setShowMobileNav(false)
  }

  return (
    <>
      <div className="Header__stack">
        <header className="Header__header relative flex items-center gap-8 px-2">
          {renderGatsbyLink({
            className: 'py-2',
            children: <Logo />,
            href: '/',
            'aria-label': 'StrataScratch Logo - To Main Page',
          })}
          <nav
            className="Header__nav flex h-full flex-grow items-center justify-center"
            data-visible={showMobileNav}
          >
            <Nav
              pathname={pathname}
              renderPlatformLink={renderPlatformLink}
              renderGatsbyLink={renderGatsbyLink}
            />

            {renderSearch}
            {renderThemeSelect}

            <div className="Header__auth flex items-center justify-center gap-2">
              {isAuthenticated ? (
                <LoggedInAuthMenu
                  handleLogout={handleLogout}
                  renderLink={renderPlatformLink}
                  closeMenu={closeMenu}
                />
              ) : (
                <LoggedOutAuthMenu
                  renderLink={renderPlatformLink}
                  closeMenu={closeMenu}
                  pathname={pathname}
                />
              )}
            </div>
          </nav>
          <button
            type="button"
            className="Header__mobile-toggle cursor-pointer rounded-md p-3 text-xl"
            onClick={toggleMenu}
            aria-expanded={showMobileNav}
            aria-label="Main Menu"
          >
            {showMobileNav ? <X /> : <Menu />}
          </button>
        </header>
      </div>
      <div
        role="none"
        className={`Header__overlay ${showMobileNav ? 'block' : ''}`}
        onClick={closeMenu}
      />
    </>
  )
}

export default Header
